import { Row } from 'styled-bootstrap-grid';
import styled from 'styled-components';
import { Spacing } from '../../theme';
export const TableMargin = styled.div `
  margin-bottom: ${Spacing.S};
`;
export const TablePagination = styled.div `
  display: flex;
  justify-content: ${(props) => props.alignment};
`;
export const HeaderRow = styled(Row) `
  margin-bottom: ${Spacing.S};
`;
//# sourceMappingURL=table.styles.js.map